"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-end;\n  margin-bottom: 30px;\n  > a,\n  > button {\n    margin: 0 0 10px 10px;\n  }\n  .title {\n    position: relative;\n    transition: left 0.25s ease-out, opacity 0.25s ease-out;\n    left: -20px;\n    opacity: 0;\n    margin-bottom: 0;\n    margin-right: auto;\n    line-height: 1;\n    > span {\n      display: flex;\n      align-items: center;\n      > a {\n        margin-right: 10px;\n        color: ", ";\n        font-size: 14px;\n        display: flex;\n        align-items: center;\n        font-weight: normal;\n        letter-spacing: 0;\n        line-height: 1;\n        > span[role='img'] {\n          margin-right: 3px;\n        }\n      }\n    }\n    > .small {\n      margin: 10px 0 0 0;\n      display: block;\n      font-size: 18px;\n      font-weight: normal;\n      line-height: 1.2;\n      position: relative;\n      transition: left 0.25s ease-out;\n      letter-spacing: -0.5px;\n      left: 10px;\n      color: ", ";\n    }\n    &.entered {\n      left: 0;\n      opacity: 1;\n      > .small {\n        left: 0;\n      }\n    }\n    &.with-back > .small {\n      margin-left: 56px;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SplitHeader = void 0;

var icons_1 = require("@ant-design/icons");

var antd_1 = require("antd");

var react_1 = __importStar(require("react"));

var react_router_dom_1 = require("react-router-dom");

var Typography_1 = require("./Typography");

var styledTypes_1 = require("./styledTypes");

function SplitHeader(_ref) {
  var smallText = _ref.smallText,
      largeText = _ref.largeText,
      actionName = _ref.actionName,
      actionHref = _ref.actionHref,
      actionIcon = _ref.actionIcon,
      back = _ref.back,
      style = _ref.style,
      children = _ref.children;
  var navigate = (0, react_router_dom_1.useNavigate)();

  var _ref2 = (0, react_1.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      entered = _ref3[0],
      setEntered = _ref3[1];

  (0, react_1.useEffect)(function () {
    setTimeout(function () {
      setEntered(true);
    }, Math.random() * 500);
  }, []);
  var actionLink;

  if (actionHref) {
    actionLink = react_1.default.createElement(react_router_dom_1.Link, {
      to: actionHref
    }, actionName, " \u2192");
  }

  if (actionIcon) {
    actionLink = react_1.default.createElement(antd_1.Button, {
      type: 'primary',
      icon: actionIcon,
      onClick: function onClick() {
        return navigate(actionHref);
      }
    }, actionName);
  }

  return react_1.default.createElement(Container, {
    style: style
  }, react_1.default.createElement(Typography_1.H1, {
    className: "title ".concat(entered ? 'entered' : '', " ").concat(back ? 'with-back' : '')
  }, react_1.default.createElement("span", {
    className: 'small'
  }, smallText), react_1.default.createElement("span", null, back && react_1.default.createElement(react_router_dom_1.Link, {
    to: back,
    className: 'back'
  }, react_1.default.createElement(icons_1.ArrowLeftOutlined, null), " Back"), largeText)), children ? children : actionHref && actionName && actionLink);
}

exports.SplitHeader = SplitHeader;
var Container = styledTypes_1.styled.div(_templateObject(), function (props) {
  return props.theme['@text-color'];
}, function (props) {
  return props.theme['@text-color-secondary'];
});